/**
 * Hook to access the authentication context.
 */

import { useContext } from 'react';
import { AuthContext } from './context';
import type { AuthContextValue } from './types';

/**
 * Hook to access auth context.
 *
 * Must be used within an AuthProvider.
 *
 * @returns The auth context value
 * @throws Error if used outside AuthProvider
 */
export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
